var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWatermeter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#333",
    strokeWidth: 12,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 230,
    fill: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 210,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 210,
    width: 100,
    height: 92,
    fill: "#3399ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412,
    y: 210,
    width: 100,
    height: 92,
    fill: "#3399ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 180,
    width: 40,
    height: 152,
    fill: "#666"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387,
    y: 180,
    width: 40,
    height: 152,
    fill: "#666"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 115,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 215,
    width: 112,
    height: 70,
    fill: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 225,
    y1: 230,
    x2: 225,
    y2: 265
  }), /*#__PURE__*/React.createElement("line", {
    x1: 256,
    y1: 230,
    x2: 256,
    y2: 265
  }), /*#__PURE__*/React.createElement("line", {
    x1: 287,
    y1: 230,
    x2: 287,
    y2: 265
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 310,
    r: 15,
    fill: "#ff4d4d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatermeter);
export default __webpack_public_path__ + "static/media/watermeter.d48053074bcbdd4a4b4505a5101c26c6.svg";
export { ForwardRef as ReactComponent };